import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { CountUp } from "@/components/site/CountUp";

export const BewlFeature = () => (
  <section className="bg-[#F5F0FF] py-16 sm:py-24" data-testid="bewl-feature">
    <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 sm:px-8 lg:grid-cols-[1fr_1.1fr]">
      <Reveal>
        <p className="eyebrow text-[#7C3AED]"><span className="h-1.5 w-1.5 rounded-full bg-[#FF7043]" />Client result · Christmas at Bewl Water</p>
        <h2 className="mt-5 text-3xl font-extrabold leading-[1.05] text-[#13052A] sm:text-4xl lg:text-5xl">
          £26,864 in Christmas <span className="serif-accent font-normal text-[#581C87]">Ticket Sales.</span>
        </h2>
        <p className="mt-5 max-w-lg text-base leading-relaxed text-slate-600 md:text-lg">
          182 purchases generated through Facebook and Instagram advertising, with attributed revenue increasing by 352% between August and September.
        </p>
        <Link to="/case-studies/christmas-at-bewl-water" className="btn-primary mt-7" data-testid="bewl-case-study-link">View Case Study <ArrowUpRight className="h-4 w-4" /></Link>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="relative overflow-hidden rounded-[32px] bg-[#2E1065] p-8 text-white sm:p-12" data-testid="bewl-figure-card">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-violet-200">Growth in attributed revenue, August to September</p>
          <motion.p initial={{ opacity: 0.2, scale: 0.92 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="mt-2 origin-left text-[5.5rem] font-extrabold leading-none tracking-tight text-[#FF7043] sm:text-[8rem]" data-testid="bewl-figure">
            <CountUp to={352} />%
          </motion.p>
          <div className="mt-6 flex flex-wrap items-center gap-3 border-t border-white/15 pt-6">
            <span className="rounded-full bg-white/10 px-4 py-2 text-sm font-bold">£26,864 attributed ticket revenue</span>
            <span className="rounded-full bg-white/10 px-4 py-2 text-sm font-bold">182 ticket purchases</span>
            <span className="rounded-full bg-white/10 px-4 py-2 text-sm font-bold">Facebook & Instagram Ads</span>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
